
export const redirectToSystem = (domain, idToken, accessToken, refreshToken) => {
    window.location = `${domain}/login-callback#access_token=${accessToken}&refresh_token=${refreshToken}&id_token=${idToken}`
}
